import * as React from 'react';

import CircleSpinner from '@core/components/display/spinners/CircleSpinner';

import NewsFeedArticle from '@/components/pages/news-archive/components/NewsFeedArticle/NewsFeedArticle';
import NewsArchiveCtx from '@/context/newsArchiveCtx';
import { ArticleType } from '@/types/ArticleType';

type NewsFeedProps = {
    className?: string;
    articles: ArticleType[];
};

const NewsFeed = (props: NewsFeedProps) => {
    const { articles } = props;

    const newsArchiveCtx = React.useContext(NewsArchiveCtx);

    const { setPage, hasData } = newsArchiveCtx;

    const observer: any = React.useRef();
    const lastPostElementRef: any = React.useCallback(
        (node: any) => {
            if (newsArchiveCtx.showLoader) return;
            if (observer.current) observer.current.disconnect();
            observer.current = new IntersectionObserver(data => {
                if (data[0]?.isIntersecting && hasData) {
                    setPage((prevState: any) => prevState + 1);
                }
            });
            if (node) observer.current.observe(node);
        },
        [newsArchiveCtx.showLoader, hasData, setPage]
    );

    React.useEffect(() => {
        if (!hasData) {
            observer.current.disconnect();
        }
    }, [hasData]);

    return (
        <div className="flex flex-col pt-8 justify-start items-start self-stretch flex-grow-0 flex-shrink-0 gap-5 md:px-10 pb-5 w-full overflow-hidden px-4">
            <div className="grid lg:grid-cols-4 gap-x-8 gap-y-10 md:grid-cols-3 xs:grid-cols-2 grid-cols-1">
                {articles.map((article, index) => {
                    return (
                        <div
                            key={`NewsFeedArticle-${article.slug}`}
                            ref={articles.length === index + 1 ? lastPostElementRef : undefined}
                        >
                            <NewsFeedArticle article={article} />
                        </div>
                    );
                })}
            </div>
            {newsArchiveCtx.showLoader && hasData && (
                <div className="w-full py-4 flex justify-center">
                    <CircleSpinner />
                </div>
            )}
        </div>
    );
};

export default NewsFeed;
